export enum SideBarContentType {
  menu = 'menu',
  search = 'search',
}
